import React from 'react'

function Premiume() {
  return (
    <div>Premiume</div>
  )
}

export default Premiume